import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/memberships')({
  component: () => <Navigate replace search to="/bo/memberships" />,
})
